import React from "react";
import { Header, Modal } from "semantic-ui-react";
import { getImageSrc } from "../../../../datas/cdnImage";

const ImageModal = ({ openImageModal, setOpenImageModal, product }) => {
  const { name } = product;

  return (
    <Modal
      closeIcon
      basic
      open={openImageModal}
      onClose={() => setOpenImageModal(false)}
    >
      <Header>{name}</Header>
      <Modal.Content>
        <img
          style={{ width: "100%" }}
          src={getImageSrc(product, "full")}
          alt={name}
          decoding="async"
        />
      </Modal.Content>
    </Modal>
  );
};

export default ImageModal;
